<template>
  <v-dialog
      v-model="dialog"
      width="auto"
      persistent
    >
      <v-card
        style="border-radius: 16px;"
      >
        <v-card-text>
          <div class="d-flex flex-column text-center">
            <img src="@/assets/icon/weather_Y.png" style="width: 120px; height: 120px; align-self: center; margin-top: 20px; margin-bottom: 30px;">
            <span class="w-700 text-444444 font-16">ข้อมูลได้ถูกบันทึกแล้ว</span>
            <!-- <span class="w-700 text-444444 font-16">แบบประเมินด้าน{{ assess_name }}ใช่หรือไม่</span> -->
            <span class="w-400 text-696969 font-12">ตรวจสอบได้ในหน้าผลตรวจสุขภาพ</span>
          </div>
        </v-card-text>
        <v-card-actions class="justify-center pb-4">
          <v-btn variant="outlined" color="#ff5252" style="border-radius: 8px;" @click="nextBtn()" width="148">
            <span class="font-13" style="color: #FFFFFF;">ออกจากผลตรวจ</span>
          </v-btn>
          <v-btn variant="flat" color="#00a99d" style="border-radius: 8px;" @click="close()" width="148">
            <span class="font-13" style="color: #FFFFFF;">อยู่ต่อ</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: {
    assess_name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialog: false,
      naxt: "",
    }
  },
  methods: {
    openDialog (next) {
      this.dialog = true
      this.next = next
    },
    close () {
      this.dialog = false
      this.next(false)
    },
    nextBtn () {
      this.next()
    }
  }
}
</script>

<style>

</style>